import styled from 'vue-styled-components';
import theme from '@/config/theme';

export const CardContainer = styled.div`
  width: 100%;
  background: ${theme.colors.white};
  border-radius: 0.5rem;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
  min-width: 280px;

  header {
    .title {
      font-size: 1.2rem;
      font-weight: bold;
      color: ${theme.colors.gray6};
      padding: 1rem;
    }

    ::after {
      display: inline-block;
      content: "";
      border-top: 1px solid #f1f2f0;
      width: 100%;
      transform: translateY(-1rem);
    }
  }
`;

export const Grid = styled.main`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-auto-rows: auto;
  padding: 1rem;
  row-gap: 1rem;

  .col {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 1rem;
  }

  .row {
    display: flex;
    width: 100%;
    gap: 0.1rem;
    align-items: center;
  }

  .label {
    color: ${theme.colors.gray5};
    font-size: 0.9rem;
  }

  .value {
    color: ${theme.colors.gray6};
    font-size: 0.9rem;
  }
`;
